/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * jelled services
 * OpenAPI spec version: 1.0.0
 */

/**
 * Jelled.ai functionalities
 */
export type Feature = typeof Feature[keyof typeof Feature];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Feature = {
  advanced_email_responder: 'advanced_email_responder',
  email_responder: 'email_responder',
  gmail: 'gmail',
  google_calendar: 'google_calendar',
  google_drive: 'google_drive',
  insights: 'insights',
  notes: 'notes',
  instructions: 'instructions',
} as const;
